import axios from 'axios';
import { useDataFetchIndicator } from '..';
import vopayApi from '@/services/api.config';
import { useState } from 'react';

const { api } = vopayApi;

export default function useFetchClientAccountBalanceRange() {
  const source = axios.CancelToken.source();
  const [, setPending] = useDataFetchIndicator();
  const [balanceRange, setBalanceRange] = useState<[number, number]>([0, 0]);

  async function fetchClientAccountBalanceRange() {
    try {
      setPending(true);
      const res = await api.fetchClientAccountBalanceRange(source);
      const range: [number, number] = [res.MinBalance, res.MaxBalance];
      setBalanceRange(range);

      return {
        ...res,
        range,
      };
    } finally {
      setPending(false);
    }
  }

  return {
    balanceRange,
    fetchClientAccountBalanceRange,
  };
}
